module.exports = __webpack_public_path__ + "img/Forgot-Passwordl-BP.6aadb84f.png";